export default {
	title: 'Confirmation de l’email associée à votre dossier',
	content: 'L’adresse email à laquelle vous serez notifié·e à chaque étape du dossier est : ',
	notification: 'Si vous souhaitez modifier cette adresse rendez-vous dans l’onglet “Mon Compte”',
	btn: 'J’ai compris'
};
